import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './typeahead-account-selector.scss';
import { DropdownSearch } from '@ampol/design-system';
import { getAccountOptions } from 'utilities/account-utilities';

/**
 * Account typeahed wrapper for ADS typeahead
 * @param onSelect Item click event
 * @param accounts List of accounts
 * @param selectedAccountItem Currently selected item
 * @returns JSX Element
 */
const TypeaheadAccountSelector = ({ onSelect, accounts, selectedAccountItem, isAccountsFlatList=false }) => {
  const isAccountLoading = useSelector((state) => state.accountsStore.isAllAccountsLoading);

  const options = getAccountOptions(accounts, isAccountsFlatList);

  useEffect(() => {
    if ((isAccountsFlatList && options?.length === 1) || (!isAccountsFlatList && typeof options[0]?.value === 'string')) {
      onSelect(options[0].value);
    }
  }, [options]);

  return <>
    <div className="th-account-selector">
      <DropdownSearch
        placeholder="Select account"
        type="dropdown"
        onChange={onSelect}
        data={options}
        value={selectedAccountItem}
        filterOptions={true}
        loading={isAccountLoading}
      />
    </div>
  </>;
};

export default TypeaheadAccountSelector;
